export default __webpack_public_path__ + "static/media/recruit-pg-4.ca460392.png";